import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import LspDeliveryProcessActions from '../../Stores/LspDeliveryProcess/Actions';

import OutbOrd02Table from '../OutbOrd02/OutbOrd02Table';
import PurOrdSync01Form from './PurOrdSync01Form';
// import PurInvSync01Table from './PurInvSync01Table';
import PurOrdDivision from './PurOrdDivision';
import LspDelOrdIndexExportScreen from '../LspDelOrdIndexExport/LspDelOrdIndexExportScreen';

const { TabPane } = Tabs;

class LspDeliveryProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curDivisionId, fetchLspDeliveryProcess } = this.props;

    if (curDivisionId > 0) {
      fetchLspDeliveryProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curDivisionId, fetchLspDeliveryProcess } = this.props;
    const { changed } = treeChanges(prevProps, this.props);
    if (changed('curDivisionId')) {
      if (curDivisionId > 0) {
        fetchLspDeliveryProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/lspDeliveryProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'PUR_ORD_SYNC_01' && <PurOrdSync01Form match={match} />}
        {match.params.proc_type === 'OUTB_ORD_02' && <OutbOrd02Table match={match} />}
        {match.params.proc_type === 'PUR_INV_SYNC_01' && (
          <LspDelOrdIndexExportScreen match={match} />
        )}
        {match.params.proc_type === 'PUR_ORD_DIVISION_MAP' && <PurOrdDivision match={match} />}
      </Card>
    );
  }
}

LspDeliveryProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curDivisionId: PropTypes.number,
  fetchLspDeliveryProcess: PropTypes.func
};

LspDeliveryProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curDivisionId: 0,
  fetchLspDeliveryProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.lspDeliveryProcess.process,
  processIsLoading: state.lspDeliveryProcess.processIsLoading,

  curDivisionId: state.app.curDivisionId
});

const mapDispatchToProps = dispatch => ({
  fetchLspDeliveryProcess: () =>
    dispatch(LspDeliveryProcessActions.lspDeliveryProcessFetchLspDeliveryProcess())
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(LspDeliveryProcessScreen));
